module.exports = __webpack_public_path__ + "static/media/organized-icon.2efd3369.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/organized-icon.svg
// module id = 1066
// module chunks = 0